import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IPageDataV2, IPageDataV3 } from '@df/catalog/cms/cms-model.interface';
import { App } from '@df/core/app';
import { Status } from '@df/core/status';
import { DfModuleImageModule } from '@df/module-image/df-module-image.module';
import { DfUiCarouselModule } from '@df/ui-carousel/carousel.module';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { ICmsPage } from '@icms/core/resource/page/icms-page';
import { BehaviorSubject } from 'rxjs';
import { LocalPage } from '../../catalog/page/local/local-page';
import { ButtonStyleComponent } from '../../common/buttons/button-style/button-style.component';
import { NTextBox, TextBoxComponent } from '../../common/text-box/text-box.component';
import { NBlogPostPageType } from '../blog/page/post-view/cms-blog-post.namespace';

let uid = 0;

export namespace NCmsCaseStudies {
    export interface IComponentData extends NICmsContentComponent.IData, NTextBox.IData {
        posts?: number[];
    }
}

@ICmsComponent<CmsCaseStudiesComponent>({
    id: 'case-studies',
    name: 'Case Studies',
    tags: ['carousel', 'case-studies', 'links'],
    fields: [
        {
            type: NICmsContentField.EFieldType.label,
            key: 'text-box',
            title: 'Text box component'
        },
        ...NTextBox.getFields(false, false),
        // posts
        {
            type: NICmsContentField.EFieldType.label,
            key: 'posts',
            title: 'Posts'
        },
        <NICmsContentField.IRelationField>{
            type: NICmsContentField.EFieldType.relation,
            key: 'posts',
            title: 'Posts',
            options: {
                title: 'Posts',
                type: ICmsPage.type,
                multiple: true
            },
            required: true,
            default: [-100, -101, -102, -103, -104]
        },
        NICmsContentComponent.backgroundField
    ]
})
@Component({
    standalone: true,
    imports: [DfUiCarouselModule, TextBoxComponent, RouterLink, DfModuleImageModule, ButtonStyleComponent, TranslationModule],
    selector: 'cms-case-studies',
    templateUrl: './cms-case-studies.html',
    styleUrl: './cms-case-studies.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsCaseStudiesComponent extends UiComponent implements NICmsContentComponent.IComponent, OnInit {
    @ICmsContent({
        type: 'component'
    })
    component?: NCmsCaseStudies.IComponentData;

    protected uid = uid++;

    models: ICmsPage<IPageDataV3>[] = [];

    private loadStatus = new Status();

    private app = inject(App);

    _icmsContent$!: BehaviorSubject<NCmsCaseStudies.IComponentData | undefined>;

    override ngOnInit(): void {
        super.ngOnInit();
        if (this._icmsContent$) {
            this.subscriptions.add(
                this._icmsContent$.subscribe(() => {
                    this.setModels();
                })
            );
        }
    }

    private setModels(): void {
        const ids = this.component?.posts || [];
        if (this.loadStatus.promise?.cancel) {
            this.loadStatus.promise.cancel();
        }
        this.models = [];
        this.detectChanges();
        if (ids.length) {
            this.app.request.send(
                this.loadStatus,
                () => {
                    return this.app.resources.page.loadAllIds(ids, 2);
                },
                () => {
                    this.models = this.app.resources.page.getAllExisting(ids) as ICmsPage<IPageDataV3>[];
                    this.detectChanges();
                }
            );
        }
    }

    getTagCategory(model: ICmsPage<IPageDataV3>): LocalPage<IPageDataV2<IPageDataV2>> | undefined {
        return (model as LocalPage<IPageDataV3<NBlogPostPageType.ITypeData>>).getBlogPostCategories()?.[0] || undefined;
    }

    get pcSlides(): number {
        return [1.048, 2.15, 3.07, 3.82][this.client.sizeId];
    }

    get pcSlidesCeil(): number {
        return Math.ceil(this.pcSlides);
    }

    get pcGutter(): string {
        return '16px';
    }
}
